import Fetch from "utils/fetch";

export const getAllMaterialGroups = () => Fetch.get(`material-groups:all`).then(({ data }) => data);